module.exports = __webpack_public_path__ + "img/badge.022c5af3.svg";